import React from 'react';
import { FaCheck, FaQuestion, FaTimes } from 'react-icons/fa';
import { useI18n } from '../../i18n';
import './RsvpModal.css';

const RsvpModal = ({ isOpen, onClose, onConfirm, meeting, status, loading = false }) => {
    const { t } = useI18n();
    if (!isOpen) return null;

    const RSVP_CONFIG = {
        accepted: {
            icon: FaCheck,
            title: t('pages.meetings.rsvp_status.accepted.title') || 'Accept Meeting',
            description: t('pages.meetings.rsvp_status.accepted.description') || 'Are you sure you want to accept this meeting invitation?',
            confirmText: t('pages.meetings.rsvp_status.accepted.confirm') || 'Yes, Accept',
            cancelText: t('pages.meetings.rsvp_status.accepted.cancel') || 'No, Maybe Later',
            confirmClass: 'rsvp-modal-confirm-accept',
            iconColor: '#16a34a',
        },
        tentative: {
            icon: FaQuestion,
            title: t('pages.meetings.rsvp_status.tentative.title') || 'Tentative',
            description: t('pages.meetings.rsvp_status.tentative.description') || 'Are you sure you want to mark this meeting as tentative?',
            confirmText: t('pages.meetings.rsvp_status.tentative.confirm') || 'Yes, Tentative',
            cancelText: t('pages.meetings.rsvp_status.tentative.cancel') || 'No, Maybe Later',
            confirmClass: 'rsvp-modal-confirm-tentative',
            iconColor: '#ca8a04',
        },
        declined: {
            icon: FaTimes,
            title: t('pages.meetings.rsvp_status.declined.title') || 'Decline Meeting',
            description: t('pages.meetings.rsvp_status.declined.description') || 'Are you sure you want to decline this meeting invitation? You will no longer be able to join.',
            confirmText: t('pages.meetings.rsvp_status.declined.confirm') || 'Yes, Decline',
            cancelText: t('pages.meetings.rsvp_status.declined.cancel') || 'No, Keep It',
            confirmClass: 'rsvp-modal-confirm-reject',
            iconColor: '#dc2626',
        },
    };

    const config = RSVP_CONFIG[status];
    if (!config) return null;

    const Icon = config.icon;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && !loading) {
            onClose();
        }
    };

    const handleConfirm = () => {
        if (!loading && onConfirm) {
            onConfirm(status);
        }
    };

    return (
        <div className="rsvp-modal-overlay" onClick={handleBackdropClick}>
            <div className="rsvp-modal">
                <button
                    className="rsvp-modal-close"
                    onClick={onClose}
                    disabled={loading}
                    aria-label="Close"
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>

                <div className="rsvp-modal-header">
                    <div className="rsvp-modal-header-left">
                        <Icon className="rsvp-modal-small-icon" style={{ width: 24, height: 24, color: config.iconColor }} />
                        <h2 className="rsvp-modal-title">{config.title}</h2>
                    </div>
                </div>

                <p className="rsvp-modal-description">
                    {config.description}
                </p>

                <div className="rsvp-modal-actions">
                    <button
                        className="rsvp-modal-cancel-btn"
                        onClick={onClose}
                        disabled={loading}
                    >
                        {config.cancelText}
                    </button>
                    <button
                        className={`rsvp-modal-confirm ${config.confirmClass}`}
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        {loading ? t('common.actions.saving') || 'Saving...' : config.confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RsvpModal;
